import React, { Component } from 'react'
import MaterialIcon, { colorPalette } from 'material-icons-react';
import Loader from "components/elements/loader/Loader";
import HttpClient from "../../utils/HttpClient/HttpClient";
import history from 'routes/History/history';
import * as qs from "qs";
import { showWarningMessage, showSuccessfulMessage } from 'reducers/application/applicationActions';
import { connect } from "react-redux";

class ForgotPassword extends Component {

  httpClient;

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      loading: false
    }
    this.httpClient = new HttpClient();
  }

  onEmailChange = (val) => {
    console.log(`onEmailChange: ${val}`);
    this.setState({ email: val });
  }

  onSendRecoveryPasswordEmail = () => {
    if (this.validate()) {
      this.setState({ loading: true });
      const config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
      let formData = { email: this.state.email };
      this.httpClient.post("oga/recover-password", qs.stringify(formData), config)
        .then((response) => {
          console.log("Reset Successful");
          this.setState({ loading: false });
          this.props.showSuccessfulMessage("Un correo electrónico ha sido enviado para restablecer su contraseña");
          history.push('/');
        })
        .catch((error) => {
          this.setState({ loading: false });
          this.props.showWarningMessage("Ha ocurrido un error. Por favor intentelo más tarde.");
        })
    }
  }

  validate = () => {
    if (this.state.email.length == 0) {
      this.props.showWarningMessage("Ingrese correo electrónico.");
      return false;
    }

    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(this.state.email) === false) {
      this.props.showWarningMessage("Ingrese el formato 'ejemplo@gmail.com' correo electrónico.");
      return false;
    }
    return true;
  }

  render() {
    return (
      <form className="form">
        <div className="w-100">
          <div className="text-center text-white forgot-password_title">Recuperar contraseña</div>
        </div>

        <div className="form-group">
          <div className="input-group mb-3 username">
            <div className="input-group-prepend " >
              <span className="input-group-text border-dark bg-secondary">
                <MaterialIcon icon="email" size="18px" color="white" />
              </span>
            </div>
            <input type="email" className="form-control border-dark"
              onChange={(e) => this.onEmailChange(e.target.value)}
              aria-describedby="emailHelp" placeholder="Ingresar correo electrónico" />
          </div>
        </div>
        <div className="w-100">
          {
            this.state.loading ? <Loader show={true} /> :
              <button type="button"
                className="btn bg-secondary w-100 login-btn"
                onClick={() => this.onSendRecoveryPasswordEmail()}>Enviar correo electrónico</button>
          }
        </div>
      </form>
    )
  }
}
const mapStateToProps = state => ({
});
export default connect(
  mapStateToProps,
  { showWarningMessage, showSuccessfulMessage }
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/views/ForgotPassword/ForgotPassword.jsx